import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useGetGameZoneCollection } from 'server';
import { useEffect, useState } from 'react';
import { useSocketSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import * as actions from './store/actions';

export const useGameFeatures = () => {
    const dispatch = useDispatch();
    const [isLoaded, setIsLoaded] = useState(false);
    const getGameZoneCollection = useGetGameZoneCollection();
    const connected = useSocketSelector(prop('connected'));

    useEffect(() => {
        if (!connected || isLoaded) {
            return;
        }

        (async () => {
            const { games } = await getGameZoneCollection();

            dispatch(actions.setGameFeatures(helpers.filterGamesFeatures(games)));
            setIsLoaded(true);
        })();
    }, [getGameZoneCollection, isLoaded, connected, dispatch]);
};
